let scriptID =
  "AKfycbwWU3qvWQIY-x3fmXH-Jd4Xdu9E4xkH1b96qwo3K4jb46MICThYyaFPC7fXHLnf8HdtXw";
export let script = "https://script.google.com/macros/s/" + scriptID + "/exec?";

/*
Interacts with the passwords spreadsheet via a custom google script.
DO NOT MODIFY.
*/

export async function getValues(range) {
  //Gets values from spreadsheet, range in form of "A1:B2"
  let values = [];
  try {
    const response = await fetch(script + "range=" + range);
    const data = await response.json();
    values = data.values.map((value) => value[0]);
  } catch (error) {
    console.error("Error:", error);
  }
  return values;
}

export async function checkAuth(password) {
  //Checks if password is correct
  let auth = false;
  try {
    const response = await fetch(script + "pass=" + password);
    auth = await response.json();
  } catch (error) {
    console.error("Error:", error);
  }
  return auth;
}

export function addValue(cell, value) {
  /*
    Posts value to spreadsheet.
    cell: Cell to post to in form of "A1"
    value: Value to post as string
    */
  fetch(script, {
    redirect: "follow",
    method: "POST",
    body: JSON.stringify({ cell: cell, value: value, type: "add" }),
    headers: {
      "Content-Type": "text/plain;charset=utf-8",
    },
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}
